module.exports = __webpack_public_path__ + "img/tcbio.7db55b6b.png";